module.exports = __webpack_public_path__ + "static/media/sandbox.68af29f7.glb";